export const formatExpirationDate = (expirationDate: string): string => {
  return expirationDate.replace(/(( |)\.( |))/, ' / ');
};
